import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { MICROSERVICES } from '@shared/constants/microservices';
import { Observable } from 'rxjs/internal/Observable';
import { GetVehicleMROsPaginatedResponse, VehicleMROResponse } from '../domain/mro-manual-model';
import { MroGPSRepository } from './mro-gps.repository';

@Injectable()
export class MroGPSApiService implements MroGPSRepository {
    private _http = inject(HttpClient);
    private baseUrl = `${environment.url}${MICROSERVICES.mro_gps}`;

    createVehicleGPS(vehicleId: string, addressId: string): Observable<VehicleMROResponse> {
        return this._http.post<VehicleMROResponse>(`${this.baseUrl}/vehicles/${vehicleId}`, { addressId: addressId });
    }

    deleteVehicleGPS(vehicleId: string, miles: number, odometerPhoto: File, feedback: string): Observable<VehicleMROResponse> {
        const formData = new FormData();
        if(miles !== 0) {
            formData.append('miles', miles.toString());
            formData.append('odometerPhoto', odometerPhoto);
            formData.append('feedback', feedback);
        }

        return this._http.request<VehicleMROResponse>('delete', `${this.baseUrl}/vehicles/${vehicleId}`, {
            body: formData,
        });
    }

    getVehicleGPSById(vehicleId: string): Observable<VehicleMROResponse> {
        return this._http.get<VehicleMROResponse>(`${this.baseUrl}/vehicles/${vehicleId}`);
    }

    getVehicleGPSByUserId(page = 1, size = 10): Observable<GetVehicleMROsPaginatedResponse> {
        const params = new HttpParams().set('page', page.toString()).set('size', size.toString());

        return this._http.get<GetVehicleMROsPaginatedResponse>(`${this.baseUrl}/vehicles`, { params });
    }
}
